import React from "react";
import Logo from "./Logo";
import { CHAIN } from "../mock";

export default function Footer() {
  return (
    <footer style={{ borderTop:"1px solid var(--border)", background:"var(--bg-2)" }}>
      <div className="container-x py-12">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <Logo size={34} />
            <div>
              <div className="font-display font-bold text-[16px]">ZSTAMP</div>
              <div className="text-[11px] font-mono" style={{ color:"var(--muted)" }}>burn it, keep the receipt</div>
            </div>
          </div>
          <div className="flex flex-wrap gap-x-7 gap-y-2 text-[13px]" style={{ color:"var(--muted)" }}>
            <a href="#burn" className="link-underline">Issue certificate</a>
            <a href="#launched" className="link-underline">Just launched</a>
            <a href="#burns" className="link-underline">Every burn</a>
            <a href="#verify" className="link-underline">Verify</a>
            <a href="https://x.com/zstamp_fun" target="_blank" rel="noreferrer" className="link-underline">X / Twitter</a>
            <a href={CHAIN.launchpadUrl} target="_blank" rel="noreferrer" className="link-underline gold-text">{CHAIN.launchpad}</a>
          </div>
        </div>
        <div className="mt-8 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-[12px]" style={{ borderTop:"1px solid var(--border)", color:"var(--muted)" }}>
          <span>One way. No escrow, no custody, nobody holding your funds.</span>
          <span>Burn on {CHAIN.name} · Certificate on Zcash · Launched on {CHAIN.launchpad}</span>
        </div>
      </div>
    </footer>
  );
}
